import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { TiTick } from "react-icons/ti";
import { BiSolidErrorAlt } from "react-icons/bi";
import useScrollToTop from "./hooks/useScrollToTop";

export default function Success() {
  const { t } = useTranslation("global");
  useScrollToTop();

  return (
    <div className="flex justify-center items-center py-20">
      <div className="max-w-xl rounded-2xl shadow-jubilation bg-white px-14 py-20">
        <div className="relative w-fit">
          <BiSolidErrorAlt className="text-6xl text-navyBlue" />

          <TiTick className="absolute top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] bg-navyBlue text-white text-5xl rounded-full" />
        </div>

        <p className="mt-6 text-3xl font-bold text-navyBlue">
          {t("success.text1")}
        </p>

        <p className="font-medium mt-2 ">{t("trans.1")}</p>

        <Link to={process.env.PUBLIC_URL}>
          <button className="mt-4 primary-btn !w-fit px-8">
            {t("success.text2")}
          </button>
        </Link>
      </div>
    </div>
  );
}
